import axios from 'axios';

let util = {};
util.title = function (title) {
  title = title ? title : '共享氧疗';
  window.document.title = title;
};

const ajaxUrl = process.env.BASE_URL

util.ajax = axios.create({
  baseURL: ajaxUrl,
  timeout: 30000,
  validateStatus: function (status) {
    return true;
  },
});

util.setToken = function (token) {
  localStorage.setItem("tk", token);
};

util.getToken = function () {
  return localStorage.getItem("tk");
};

util.formatDateTime = function(date) {
  var year = date.getFullYear();
  var month = date.getMonth() + 1;
  var day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();

  var hour = date.getHours();
  var minute = date.getMinutes();

  return [year, month, day].map(formatNumber).join('-') + ' ' + [hour, minute].map(formatNumber).join(':')
};

util.formatTime = function(timestamp) {
  if (!timestamp) {
    return null;
  }
  let date = new Date(timestamp)
  var hour = date.getHours();
  var minute = date.getMinutes();

  return [hour, minute].map(formatNumber).join(':')
};

function formatNumber(n) {
  n = n.toString()
  return n[1] ? n : '0' + n
}

util.formatDate = function (timestamp) {
  if (!timestamp) {
    return null;
  }
  let date = new Date(timestamp)
  let year = date.getFullYear()
  let month = (date.getMonth() + 1) < 10 ? '0' + (date.getMonth() + 1) : (date.getMonth() + 1)
  var day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
  return [year, month, day].join('-')
};

util.getHourMin = function (date) {
  var hour = date.getHours()
  var minute = date.getMinutes()
  return [hour, minute].map(formatNumber).join(':');
};

util.getHour = function (date) {
  return date.getHours()
};

util.getMin = function (date) {
  return date.getMinutes();
};

util.convertHourMin = function (seconds) {
  return [Math.round(seconds / 3600), (seconds % 3600) / 60].map(formatNumber).join(':');
};

export default util;



// WEBPACK FOOTER //
// ./src/libs/util.js